import React, {Children} from 'react'
import styled from 'styled-components'
import {AccordionContext} from './AccordionContext'

const AccordionContainer = styled.div`
  height: 100%;
  box-sizing: border-box;
  overflow-y: auto;
`

const Accordion = ({children, onActive, activeIndexes}) => {
  const onPanelChange = index => {
    let nextActiveIndexes = [...(activeIndexes || [])]

    const activeIndex = nextActiveIndexes.indexOf(index)

    if (activeIndex > -1) {
      nextActiveIndexes.splice(activeIndex, 1)
    } else {
      nextActiveIndexes = [index]
    }

    // setActiveIndexes(nextActiveIndexes)

    if (onActive) {
      onActive(nextActiveIndexes)
    }
  }

  return (
    <AccordionContainer>
      {Children.toArray(children).map((panel, index) => (
        <AccordionContext.Provider
          key={`accordion-panel_${index}`}
          value={{
            active: activeIndexes.indexOf(index) > -1,
            onPanelChange: () => onPanelChange(index)
          }}
        >
          {panel}
        </AccordionContext.Provider>
      ))}
    </AccordionContainer>
  )
}

export default Accordion
